export function mergeDeep<T>(
    target: T | Array<any>,
    source: T | Array<any>
): unknown | Array<unknown> {
    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (Array.isArray(source[key]) && Array.isArray(target[key])) {
                target[key] = source[key].map((item: T, index: number) => {
                    if (isObject(item) && target[key][index]) {
                        return mergeDeep(target[key][index], item);
                    }
                    return item;
                }) as any;
            } else if (isObject(source[key])) {
                if (!target[key]) {
                    Object.assign(target, { [key]: {} });
                }
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }
    return target;
}

function isObject(item: any): item is object {
    return item && typeof item === 'object' && !Array.isArray(item);
}
